import React from 'react';

import { cn } from '../../lib/utils';

interface TypingIndicatorProps {
  /** Agent colour as hex for the animated dots */
  colour: string;
  className?: string;
}

/**
 * Animated three-dot typing indicator shown while the agent is streaming.
 * Dots pulse in the agent's colour.
 */
export function TypingIndicator({ colour, className }: TypingIndicatorProps): React.JSX.Element {
  return (
    <div
      className={cn('flex items-center gap-1 px-4 py-3', className)}
      role="status"
      aria-label="Agent is typing"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="inline-block h-2 w-2 rounded-full animate-bounce"
          style={{
            backgroundColor: colour,
            animationDelay: `${i * 0.15}s`,
            animationDuration: '0.6s',
          }}
        />
      ))}
    </div>
  );
}
